"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDCommitQueue = void 0;
var sd_controls_components_dom_dom_util_js_1 = __importDefault(require("../components/dom/sd-controls.components.dom.dom-util.js"));
var SDCommitQueue = /** @class */ (function () {
    // #endregion Properties (7)
    // #region Constructors (1)
    function SDCommitQueue(_api, _parentContainer) {
        this._api = _api;
        this._parentContainer = _parentContainer;
        this._numOfElementsForCommit = 0;
        this._queue = {};
        this._onQueuePassFinished = [];
    }
    Object.defineProperty(SDCommitQueue.prototype, "use", {
        // #endregion Constructors (1)
        // #region Public Accessors (2)
        get: function () {
            return this._use && !this._executing;
        },
        set: function (v) {
            if (v) {
                // container might not be initialized
                if (this.container)
                    this.container.removeAttribute('hidden');
                this._use = true;
            }
            else {
                // container might not be initialized
                if (this.container)
                    this.container.setAttribute('hidden', "true");
                this._use = false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SDCommitQueue.prototype, "executing", {
        get: function () {
            return this._executing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SDCommitQueue.prototype, "api", {
        // #endregion Public Accessors (2)
        // #region Protected Accessors (2)
        get: function () {
            return this._api;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SDCommitQueue.prototype, "queue", {
        get: function () {
            return this._queue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SDCommitQueue.prototype, "container", {
        // #endregion Protected Accessors (2)
        // #region Private Accessors (1)
        /** Gets the container @return { HTMLElement } */
        get: function () {
            return this._container;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion Private Accessors (1)
    // #region Public Methods (1)
    SDCommitQueue.prototype.add = function (element, val, event) {
        this.queue[element.id] = { element: element, value: val, event: event };
        if (!element.isCurrentValueSameAsInital()) {
            this.addCommitClass(element);
            if (element.isChanged === false) {
                element.isChanged = true;
                this._numOfElementsForCommit++;
            }
        }
        else {
            this.removeCommitClass(element);
            if (element.isChanged === true) {
                this._numOfElementsForCommit--;
                element.isChanged = false;
            }
        }
        this.enableDisableCommitButtons();
    };
    /**
     * Calls a callback when queue pass for element has finished, but before queue execution and clear are done.
     * @param callback - called as soon as all elements from queue have been called
     */
    SDCommitQueue.prototype.onQueuePassFinished = function (callback) {
        this._onQueuePassFinished.push(callback);
    };
    // #endregion Public Methods (1)
    // #region Protected Methods (3)
    SDCommitQueue.prototype.clear = function () {
        for (var id in this._queue) {
            var menuEl = this._queue[id].element;
            menuEl.setToInitalValueAndClearStack();
            menuEl.isChanged = false;
            this.removeCommitClass(menuEl);
        }
        this._queue = {};
        this._numOfElementsForCommit = 0;
        this.enableDisableCommitButtons();
    };
    SDCommitQueue.prototype.createElements = function () {
        var _this = this;
        if (this._container && this._commitBtn && this._commitBtn)
            return;
        this._container = sd_controls_components_dom_dom_util_js_1.default.createDomElement('div', { parent: this._parentContainer, classList: ['sd-commit-container', 'uk-margin-remove'], attributes: { 'uk-grid': '' } });
        var classList = ['uk-button', 'uk-button-default', 'uk-button-small', 'uk-width-1-2', 'sd-commit-button', 'uk-padding-remove'];
        this._commitBtn = sd_controls_components_dom_dom_util_js_1.default.createDomElement('button', { parent: this.container, innerHTML: 'Apply', classList: classList });
        this._cancelBtn = sd_controls_components_dom_dom_util_js_1.default.createDomElement('button', { parent: this.container, innerHTML: 'cancel', classList: classList });
        this._commitBtn.onclick = function () { return _this.execute(); };
        this._cancelBtn.onclick = function () { return _this.clear(); };
        this.enableDisableCommitButtons();
    };
    SDCommitQueue.prototype.execute = function () {
        var _this = this;
        this._executing = true;
        Object.keys(this._queue).forEach(function (key) {
            var v = _this._queue[key].value;
            var e = _this._queue[key].event;
            _this._queue[key].element.queueCommitExecuted(v, e);
        });
        this._onQueuePassFinished.forEach(function (x) { return x(); });
        this._executing = false;
        this.clear();
    };
    // #endregion Protected Methods (3)
    // #region Private Methods (3)
    SDCommitQueue.prototype.addCommitClass = function (element) {
        element.row.classList.add('sd-commit');
    };
    SDCommitQueue.prototype.enableDisableCommitButtons = function () {
        if (this._numOfElementsForCommit > 0) {
            this._commitBtn.removeAttribute('disabled');
            this._cancelBtn.removeAttribute('disabled');
        }
        else {
            this._commitBtn.setAttribute('disabled', "true");
            this._cancelBtn.setAttribute('disabled', "true");
        }
    };
    SDCommitQueue.prototype.removeCommitClass = function (element) {
        element.row.classList.remove('sd-commit');
    };
    return SDCommitQueue;
}());
exports.SDCommitQueue = SDCommitQueue;
